import { ExclamationmarkSmallBubbleColorIcon } from '@zep-us/zus';
interface QuoteUpsellBannerProps {
  message: string;
}

/**
 * 그룹 할인 유도 배너 (Figma 13614-56350 / 13614-56059).
 * 흰 배경 + 노란 보더 + ! 말풍선 아이콘 + 문구.
 */
export function QuoteUpsellBanner({
  message
}: QuoteUpsellBannerProps) {
  return <div className="flex animate-fade-up items-center gap-xs rounded-sm border border-solid border-yellow-500 bg-white p-md shadow-xs animate-duration-[150ms] animate-once animate-ease-out" data-sentry-component="QuoteUpsellBanner" data-sentry-source-file="QuoteUpsellBanner.tsx">
      <ExclamationmarkSmallBubbleColorIcon size="sm" className="shrink-0" data-sentry-element="ExclamationmarkSmallBubbleColorIcon" data-sentry-source-file="QuoteUpsellBanner.tsx" />
      <p className="text-body-lg-semibold text-default">{message}</p>
    </div>;
}